import { createContext, useContext, useEffect, useState } from "react";
import { Entrar } from "../telas/Entrar.js";
import { Carregando } from "./Pagina.js";

export type Eu = {
  nome: string | null;
  cpfFinal: string | null;
  empresaAtual: string | null;
  papel: string | null;
  permissoes: string[];
  empresas: { companyId: string; nome: string; papel: string }[];
};

/**
 * Exportado para o TESTE poder montar o shell com uma sessão conhecida.
 *
 * A alternativa seria o `useEu` devolver um padrão quando não há provedor, e
 * isso esconderia justamente o bug de renderizar tela autenticada sem sessão.
 */
export const ContextoDeSessao = createContext<Eu | null>(null);
const Contexto = ContextoDeSessao;

export const useEu = (): Eu => {
  const eu = useContext(Contexto);
  if (!eu) throw new Error("useEu fora do provedor de sessão.");
  return eu;
};

/** A tela esconde o que a PERMISSÃO não cobre, e a lista vem do servidor. */
export const usePode = (permissao: string): boolean =>
  useContext(Contexto)?.permissoes.includes(permissao) ?? false;

export function ProvedorDeSessao({ children }: { children: React.ReactNode }) {
  const [estado, setEstado] = useState<"carregando" | "fora" | "dentro">("carregando");
  const [eu, setEu] = useState<Eu | null>(null);

  const carregar = async () => {
    try {
      const r = await fetch("/auth/eu", {
        headers: (() => {
          const empresa = localStorage.getItem("eop:empresa");
          return empresa ? { "x-tenant-id": empresa } : {};
        })(),
      });
      if (!r.ok) { setEstado("fora"); return; }
      const corpo = await r.json() as Eu;
      setEu(corpo);
      if (corpo.empresaAtual) localStorage.setItem("eop:empresa", corpo.empresaAtual);
      setEstado("dentro");
    } catch {
      setEstado("fora");
    }
  };

  useEffect(() => { void carregar(); }, []);

  if (estado === "carregando") {
    return <div className="eop p-6"><Carregando rotulo="Verificando o seu acesso" /></div>;
  }
  if (estado === "fora" || !eu) return <Entrar aoEntrar={() => void carregar()} />;

  return <Contexto.Provider value={eu}>{children}</Contexto.Provider>;
}
